import IUserApplicationDetails from "interfaces/models/IUserApplicationDetails";
import { GlobalState } from "little-state-machine";

export const updateSelectedUserApplicationDetails = (state: GlobalState, selectedUserApplicationDetails: IUserApplicationDetails) => ({
  ...state,
  selectedUserApplicationDetails
});
